import * as ActionTypes from '../../actions/allActions'
import { currentUserNormalizer } from '../../normalizers/Normalizers'

const accountProfileInit = {
	firstName: "",
	lastName: "",
	email: "",
	password: "",
	password_confirmation: "",
	phone: "",
	secondaryPhone: "",
	landlinePhone: "",
	sodexoRef: "",
	sodexoRegion: "",
	title: "",
	notificationPreferences: [],
}
const accountProfile = (state = accountProfileInit, action) => {
	switch (action.type) {
		case ActionTypes.SIGNIN_SUCCESS:
		case ActionTypes.CHECKTOKEN_SUCCESS:
			return currentUserNormalizer(action.data.data)
		case ActionTypes.ACCOUNT_PROFILE_DATACHANGE:
			return { ...state, ...action.changes }
		default:
			return state
	}
}

export default accountProfile


// WEBPACK FOOTER //
// ./src/reducers/data/accountProfile.js